import Form from 'src/utils/Form.js'

class Exchange extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get(`exchanges/${this.id}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`exchanges?${parameters}`).then(then)
  }

  create(then) {
    return super.post(`exchanges`).then(then)
  }

  update(then) {
    return super.patch(`exchanges/${this.id}`).then(then)
  }

  destroy(then) {
    return super.delete(`exchanges/${this.id}`).then(then)
  }
}

export default Exchange
